import React from "react";
import { TableCell, Typography, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";
import { IValuesStore } from "Stores/Values/types";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { IManagementStore } from "@src/Stores/Management/types";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import { Position } from "@src/Interfaces/Entity/Position";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";
import {Values} from "Tools/Values";
import CreateIcon from "@material-ui/icons/Create";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  position: Position;
  onEditButtonClick: () => void;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("auth", "values", "management")
@observer
class PositionTableItem extends React.Component<IProps> {
  @computed get isActive() {
    return this.props.position.state === this.props.values.states.Active;
  }
  
  @computed get adminPositionId() {
      return this.props.values?.common["AdminPositionId"];
  }

  handleRemove = async () => {
    await this.props.management.removePosition(this.props.position.id);
  };

  render() {
    const position: Position = this.props.position;
    return (
      <STTableRow hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <Typography>
            <STTableCellTypography>{position.title}</STTableCellTypography>
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row" size="small">
          <Typography>
            <STTableCellTypography>{position.name}</STTableCellTypography>
          </Typography>
        </TableCell>
        <TableCell>
          <STTableCellTypography>{position.description}</STTableCellTypography>
        </TableCell>
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {this.props.auth.user.location.primary && (
              <>
                  { (position.id != this.adminPositionId || this.props.auth?.isAdmin) && (
                      <RoundButton
                          icon={<CreateIcon/>}
                          tooltipTitle={Values.getLocalizationValue("edit")}
                          onClick={() => this.props.onEditButtonClick()}
                      />
                  )}
                  { position.id != this.adminPositionId && (
                      <EntityDelete onSubmit={this.handleRemove} />
                  )}
              </>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default PositionTableItem;
